// extracted by mini-css-extract-plugin
export default {"container":"banner-card_container__IqTLE","content_info":"banner-card_content_info__XiJOA","button":"banner-card_button__esbol","figure_content":"banner-card_figure_content__cOsUZ"};